var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoGridStandard = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.6665 6.66602C7.11422 6.66602 6.6665 7.11373 6.6665 7.66602V13.666C6.6665 14.2183 7.11422 14.666 7.6665 14.666H13.6665C14.2188 14.666 14.6665 14.2183 14.6665 13.666V7.66602C14.6665 7.11373 14.2188 6.66602 13.6665 6.66602H7.6665ZM7.6665 17.3327C7.11422 17.3327 6.6665 17.7804 6.6665 18.3327V24.3327C6.6665 24.885 7.11422 25.3327 7.6665 25.3327H13.6665C14.2188 25.3327 14.6665 24.885 14.6665 24.3327V18.3327C14.6665 17.7804 14.2188 17.3327 13.6665 17.3327H7.6665ZM17.3332 7.66602C17.3332 7.11373 17.7809 6.66602 18.3332 6.66602H24.3332C24.8855 6.66602 25.3332 7.11373 25.3332 7.66602V13.666C25.3332 14.2183 24.8855 14.666 24.3332 14.666H18.3332C17.7809 14.666 17.3332 14.2183 17.3332 13.666V7.66602ZM18.3332 17.3327C17.7809 17.3327 17.3332 17.7804 17.3332 18.3327V24.3327C17.3332 24.885 17.7809 25.3327 18.3332 25.3327H24.3332C24.8855 25.3327 25.3332 24.885 25.3332 24.3327V18.3327C25.3332 17.7804 24.8855 17.3327 24.3332 17.3327H18.3332Z",
    fill: "#8D939C"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoGridStandard);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_grid_standard.4e73ec679ea97c3791f1ac907223a1a2.svg";